import React from 'react';
import { useDispatch } from 'react-redux';
import dynamic from 'next/dynamic';
import { actions as modalActions } from '@gcloud-npm/next12.app-controller.reducers-sagas.modals-reducer';
import {
  CONTENT_POSITION,
  IN_SCENE_EFFECT,
  OPACITY_LAYOUT_COLORS,
  OUT_SCENE_EFFECT,
} from '@gcloud-npm/next12.components.modal';
import TextInfo from '@gcloud-npm/next12.components.text-info-n';
import Button from '@gcloud-npm/next12.components.button-m';
import Image from '@gcloud-npm/next12.components.image-n';
import CustomLink from '@gcloud-npm/next12.components.custom-link';

const Video = dynamic(() => import('../VideoBanner/Video'));

export const COMPONENT_NAME = 'carrusel-testimonios';

const ClientTestimonies = (props) => {
  const { testimoniesCards } = props;

  const taggingInfo = {
    componentVariation: 'all',
    componentName: COMPONENT_NAME,
    componentProduct: '',
  };

  const dispatch = useDispatch();

  const handleModal = ({ videoProps }) => {
    const MODAL_PROPS = {
      contentPosition: CONTENT_POSITION.CENTER_CENTER,
      opacityLayoutColor: OPACITY_LAYOUT_COLORS.BLACK05,
      inSceneEffect: IN_SCENE_EFFECT.FADE_IN_RIGHT,
      outSceneEffect: OUT_SCENE_EFFECT.FADE_OUT_RIGHT,
      closeByClickingOutside: true,
      scrollAllowed: true,
    };
    dispatch(
      modalActions.addModal({
        id: 'video',
        type: 'MODAL',
        Element2Show: Video,
        elementProps: videoProps,
        modalProps: MODAL_PROPS,
      })
    );
  };

  const sideScroll = (direction) => {
    let scrollAmount = 0;
    const container = document.getElementById('sliderCards');
    const speed = 35;
    const distance = 500;
    const step = 50;
    const slideTimer = setInterval(() => {
      if (direction === 'left') {
        container.scrollLeft -= step;
      } else {
        container.scrollLeft += step;
      }
      scrollAmount += step;
      const cheuronLeft = document.getElementById('cheuronIconLeft');
      const cheuronRight = document.getElementById('cheuronIconRight');
      if (container.scrollLeft < 1) {
        cheuronLeft.style.display = 'none';
      } else if (container.scrollLeft > 3000) {
        cheuronRight.style.display = 'none';
      } else {
        cheuronLeft.style.display = 'flex';
        cheuronRight.style.display = 'flex';
      }
      if (scrollAmount >= distance) {
        window.clearInterval(slideTimer);
      }
    }, speed);
  };

  return (
    <>
      <section className="ClientsTestimonies container">
        <div className="title">
          <TextInfo {...props['TextInfo-1']} />
        </div>
        <div className="subtitle">
          <TextInfo {...props['TextInfo-2']} />
        </div>
        <div className="sliderContainer">
          <div id="cheuronIconLeft" className="hide cheuronIcon">
            <CustomLink
              onClick={() => {
                sideScroll('left');
              }}
              taggingInfo={{
                ...taggingInfo,
                componentName: 'testimonios',
                componentContent: `ir-atras`,
              }}
            >
              <Image
                src={`${process.env.NEXT_PUBLIC_CDN}/${props['Image-1'].src}`}
                alt={props['Image-1'].alt}
                layout="fixed"
                width={29}
                height={29}
              />
            </CustomLink>
          </div>
          <div id="cheuronIconRight" className="cheuronIcon right">
            <CustomLink
              onClick={() => {
                sideScroll('right');
              }}
              taggingInfo={{
                ...taggingInfo,
                componentName: 'testimonios',
                componentContent: `ir-adelante`,
              }}
            >
              <Image
                src={`${process.env.NEXT_PUBLIC_CDN}/${props['Image-2'].src}`}
                alt={props['Image-2'].alt}
                layout="fixed"
                width={29}
                height={29}
              />
            </CustomLink>
          </div>
          <div id="sliderCards" className="sliderCards">
            {testimoniesCards.map((card, index) => (
              <div className="card">
                <div className="cardWrapper">
                  <div className="text">
                    <TextInfo {...card['TextInfo-1']} />
                  </div>
                  <div className="image">
                    <Image
                      src={`${process.env.NEXT_PUBLIC_CDN}/${card['Image-1'].src}`}
                      alt={card['Image-1'].alt}
                      layout="fixed"
                      width={104}
                      height={104}
                    />
                  </div>
                  <div className="signature">
                    <TextInfo {...card['TextInfo-2']} />
                  </div>
                  <div className="button">
                    <Button
                      onClick={() => {
                        handleModal({
                          videoProps: card,
                        });
                      }}
                      {...card['Button-1']}
                      taggingInfo={{
                        ...taggingInfo,
                        componentContent: 'video-testimonio',
                      }}
                    />
                  </div>
                </div>
                <CustomLink
                  onClick={() => {
                    handleModal({
                      videoProps: card,
                    });
                  }}
                  taggingInfo={{
                    ...taggingInfo,
                    componentName: 'testimonios',
                    componentContent: `testimonios-${index}`,
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      </section>
      <style jsx>
        {`
          .ClientsTestimonies {
            .sliderContainer {
              height: 24rem;
              overflow: hidden;
              .cheuronIcon {
                display: none;
                position: absolute;
                height: 100%;
                align-items: center;
                z-index: 2;
              }
              .right {
                right: 0;
              }
              .sliderCards {
                display: flex;
                align-items: center;
                overflow-x: auto;
                margin-top: 1.5rem;
                transition: transform 0.5s ease;
                .card {
                  margin: 0 0.5rem;
                  padding: 1rem;
                  position: relative;
                  background-color: var(--color-emp--grey1);
                  height: 23rem;
                  align-items: center;
                  display: flex;
                  .text {
                    width: 14rem;
                    height: 8rem;
                  }
                  .image {
                    margin: 0 25.5%;
                  }
                  .signature {
                    height: 3rem;
                    font-style: italic;
                  }
                }
              }
            }
          }

          @media screen and (min-width: 769px) {
            .ClientsTestimonies {
              .sliderContainer {
                height: 23.4rem;
                .cheuronIcon {
                  display: flex;
                }
                .hide {
                  display: none;
                }
                .sliderCards {
                  .card {
                    margin: 0 1rem;
                    padding: 2rem;
                    height: 22rem;
                    .text {
                      width: 27rem;
                      height: 5rem;
                    }
                    .image {
                      margin: 0 38.5%;
                    }
                    .button {
                      margin: 0 38.5%;
                    }
                  }
                }
              }
            }
          }
        `}
      </style>
    </>
  );
};

export default ClientTestimonies;
